import reusables from '@styles/theme/reusables';
const commonDescriptionSlide = (isLoaded: boolean) => ({
  padding: 0,
  opacity: isLoaded ? 1 : 0,
  ...reusables.mainTransition('all', 'cubic-bezier(.4,0,.2,1)', '.5s')
});
export default {
  imageContainer: (height: number, isFullContainer: boolean, alignLeft: boolean) => {
    const calcHeight = !isFullContainer && height > 0 ? `${height}px` : 'calc((100vw / 4) * 3)';
    return {
      // Desktop fills the sized parent (original look). minHeight avoids collapse to 0
      // when the parent has no definite height yet (before JS layout / resize).
      height: [calcHeight, calcHeight, calcHeight, calcHeight, '100%'],
      minHeight: [calcHeight, calcHeight, calcHeight, calcHeight, calcHeight],
      display: 'flex',
      position: 'relative',
      width: '100%',
      justifyContent: alignLeft ? 'flex-start' : 'center',
      ...reusables.mainTransition('all')
    };
  },
  image: (isLoaded: boolean) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    ...commonDescriptionSlide(isLoaded)
  }),
  videoContainer: (isLoaded: boolean) => ({
    width: '100%',
    height: '100%',
    video: {
      objectFit: 'contain',
      objectPosition: ['center bottom', 'center bottom', 'center bottom', 'center bottom', 'center']
    },
    position: 'absolute',
    left: '50% !important',
    transform: 'translateX(-50%)',
    ...commonDescriptionSlide(isLoaded)
  })
};